import { type ReactElement, } from "react";

export declare type CheveronProps = {
	className: string;
	style?: any;
}

export const Chevron = ({
	className = "",
	style = {},
}): ReactElement => {

	const classes = [ `icon`, `chevron`, ...className.split(" ") ].filter(v => v).join(" ");
	return (
		<div className={classes} style={style}>
			<svg viewBox="0 0 16 10" xmlns="http://www.w3.org/2000/svg">
				<path d="M13.6963 9.04401L8.47667 3.82443L3.25709 9.04401C2.73244 9.56866 1.88493 9.56866 1.36028 9.04401C0.835635 8.51936 0.835635 7.67186 1.36028 7.14721L7.535 0.972495C8.05964 0.447846 8.90715 0.447846 9.4318 0.972495L15.6065 7.14721C16.1312 7.67185 16.1312 8.51936 15.6065 9.04401C15.0819 9.55521 14.2209 9.56866 13.6963 9.04401Z" />
			</svg>
		</div>
	);
};

